import { provideObjClass } from "scrivito"
import { defaultPageAttributes } from "scrivito/Objs/shared/defaultAttributes"
import { ScrivitoAttributes } from "shared/types/ScrivitoAttributes"

export const FavoritesPageObjClass = provideObjClass("FavoritesPage", {
  attributes: defaultPageAttributes,
  extractTextAttributes: ["body"]
})

export type FavoritesPageObj = InstanceType<typeof FavoritesPageObjClass>
export type FavoritesPageObjAttributes = ScrivitoAttributes<FavoritesPageObj>
